module.exports = __webpack_public_path__ + "img/vue1-doublure_gris.3ae19a08.png";